import { createIcon } from '@chakra-ui/icons'

const OTFIcon = createIcon({
  viewBox: '0 0 77.9 86.9',
  path: (
    <g transform="translate(5311 -4734.065)">
      <path
        d="M-5242.5 4817.5h-59c-2.5 0-4.5-2-4.5-4.5v-71c0-2.5 2-4.5 4.5-4.5h44.4l19.1 17.3v58.2c0 2.5-2.1 4.5-4.5 4.5z"
        fill="#FFFFFF"
      />
      <path
        d="M-5242.5 4817c2.2 0 4-1.8 4-4v-58l-18.8-17h-44.2c-2.2 0-4 1.8-4 4v71c0 2.2 1.8 4 4 4h59m0 1h-59c-2.8 0-5-2.2-5-5v-71c0-2.8 2.2-5 5-5h44.6l19.4 17.6v58.4c0 2.8-2.3 5-5 5z"
        fill="#E1E4EA"
      />
      <path
        d="M-5237.5 4767h-69v-25c0-2.8 2.2-5 5-5h45.6l18.4 17.5v12.5z"
        fill="#EFBC2C"
      />
      <path
        d="M-5255.8 4737.1v9.9s-.4 7.4 7.8 7.5 10.4 0 10.4 0l-18.2-17.4z"
        opacity=".6"
        fill="#FFFFFF"
      />
      <text
        transform="translate(-5299.533 4756.032)"
        fontSize="12"
        fontFamily="ArialMT"
        fill="#F7FAFC"
      >
        OTF
      </text>
      <path
        fill="#E1E4EB"
        d="M-5262.6 4781.7h-19c-.5 0-.8.4-.8.8v2.1c0 .5.4.8.8.8s.8-.4.8-.8v-1.3h7.8v17.3h-1.3c-.5 0-.8.4-.8.8s.4.8.8.8h4.2c.5 0 .8-.4.8-.8s-.4-.8-.8-.8h-1.3v-17.3h7.8v1.3c0 .5.4.8.8.8s.8-.4.8-.8v-2.1c.3-.4-.1-.8-.6-.8z"
      />
      <path
        fill="#E1E4EB"
        d="M-5256.2 4775.4h-4.2c-.5 0-.8.4-.8.8v1.3h-21.5v-1.3c0-.5-.4-.8-.8-.8h-4.2c-.5 0-.8.4-.8.8v4.2c0 .5.4.8.8.8h1.3v21.5h-1.3c-.5 0-.8.4-.8.8v4.2c0 .5.4.8.8.8h4.2c.5 0 .8-.4.8-.8v-1.3h21.5v1.3c0 .5.4.8.8.8h4.2c.5 0 .8-.4.8-.8v-4.2c0-.5-.4-.8-.8-.8h-1.3v-21.5h1.3c.5 0 .8-.4.8-.8v-4.2c0-.4-.4-.8-.8-.8zm-30.8 4.2v-2.5h2.5v2.5h-2.5zm2.5 26.1v1.3h-2.5v-2.5h2.5v1.2zm23.2-2.1v1.3h-21.5v-1.3c0-.5-.4-.8-.8-.8h-1.3v-21.5h1.3c.5 0 .8-.4.8-.8v-1.3h21.5v1.3c0 .5.4.8.8.8h1.3v21.5h-1.3c-.4 0-.8.4-.8.8zm4.2.9v2.5h-2.5v-2.5h2.5zm0-24.9h-2.5v-2.5h2.5v2.5z"
      />
    </g>
  ),
})

export default OTFIcon
